export const NOTIFICATION_ORDER = {
    error: 1,
    warning: 2,
    info: 3,
    success: 4,
};
